'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var $ = _interopDefault(require('jquery'));

$.fn.extend({
  prepareTransition: function prepareTransition(options) {
    var defaults = {
      eventOnly: false,
      disableExisting: false
    };

    var config = _Object$assign({}, defaults, options);

    var durationVendorPrefixes = ['transition-duration', '-moz-transition-duration', '-webkit-transition-duration', '-o-transition-duration'];
    var eventPrefixes = 'webkitTransitionEnd transitionend oTransitionEnd';

    return this.each(function () {
      var $this = $(this);
      var duration = 0;

      // Check the various CSS properties to see if a duration has been set
      durationVendorPrefixes.forEach(function (prefix) {
        duration = parseFloat($this.css(prefix)) || duration;
      });

      /* eslint-disable line-comment-position */
      if (duration === 0) {
        $this.trigger('transitionended');
      } else {
        // If I have a duration then prepare transition
        if (config.disableExisting) {
          $this.off(eventPrefixes); // turn off any existing prepareTransitions
        }
        if (!config.eventOnly) {
          $this.addClass('is-transitioning');
        }
        $this.one(eventPrefixes, function () {
          if (!config.eventOnly) {
            $this.removeClass('is-transitioning');
          }
          $this.trigger('transitionended');
        }).width(); // Force the style rendering

        // firing of transitionend events can be very unstable in certain
        // situations, this setTimeout ensures the is-transitioning class is
        // removed, even on a mis-fire
        window.setTimeout(function () {
          $this.removeClass('is-transitioning');
          $this.trigger('transitionended');
        }, duration * 1000 + 10);
      }

      /* eslint-enable line-comment-position */
    });
  }
});

module.exports = $;
